import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ConstructionPage from '@/pages/ConstructionPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<ConstructionPage />} />
      </Routes>
    </BrowserRouter>
  );
}
